import { inject, InjectionToken } from '@angular/core';
import { DataService } from '@app/services/data.service';

export const ENV = new InjectionToken<Record<string, any> | any>('ENV', {
    providedIn: 'root',
    factory: () => inject(DataService).env,
});
